import plupload from 'plupload'
export default class UploadPictures {
  constructor(container) {
    if (container) {
      const token = (document.querySelector('meta[name="csrf-token"]').getAttribute('content'))
      const id = (document.querySelector('meta[name="id"]').getAttribute('content'))
      const uploader = new plupload.Uploader({
        runtimes: 'html5,flash',
        container: 'plupload',
        browse_button: 'browse',
        drop_element: 'droparea',
        url: document.location.href.substring(0, document.location.href.lastIndexOf('posts')) + 'pictures/store',
        resize: {
          width: 1800,
          quality: 75,
          preserve_headers: false
        },
        headers: {
          'X-CSRF-TOKEN': token
        },
        multipart: true,
        urlstream_upload: true,
        multipart_params: { id: id },
        max_file_size: '200mb',
        unique_names: true,
        filters: [
          { title: 'Images', extensions: 'jpg,gif,png,jpeg,JPG' }
        ]

      })

      uploader.init()

      uploader.bind('FilesAdded', function (up, files) {
        const filelist = document.getElementById('filelist')
        document.getElementById('upload').style.opacity = '1'
        console.log(files)
        for (const i in files) {
          const file = files[i]
          const container = document.createElement('div')
          const fileInfos = document.createElement('span')
          const progressBar = document.createElement('div')
          const progress = document.createElement('div')
          container.setAttribute('id', file.id)
          container.classList.add('file')
          fileInfos.innerHTML = file.name + '(' + plupload.formatSize(file.size) + ')'
          progressBar.setAttribute('id', 'progress_bar')
          progress.setAttribute('id', 'progress')
          progressBar.classList.add('progress_bar')
          progress.classList.add('progress')

          container.appendChild(fileInfos)
          container.appendChild(progressBar)
          container.appendChild(progress)

          filelist.appendChild(container)
        }

        uploader.bind('UploadProgress', function (up, file) {
          const fileId = document.getElementById(file.id)
          const progress = fileId.querySelector('#progress')
          progress.style.width = file.percent + '%'
          fileId.style.color = '#fff'
        })

        uploader.bind('Error', function (up, err) {
          console.log('\nError #' + err.code + ': ' + err.message)
        })

        uploader.bind('FileUploaded', function (up, file, response) {
          if (uploader.files.length === (uploader.total.uploaded + uploader.total.failed)) {
            window.location.reload()
          }
        })
      })

      document.getElementById('upload').addEventListener('click', function (e) {
        e.preventDefault()
        uploader.start()
      })

    }
  }
}
